<template>
  <permission-tooltip
      :container-style="{width:'100%'}"
      :permission="hasPermission('menu_schema_print_ranges')"
      :tooltip="{top: true, right: false, bottom: false, attach: false}"
  >
    <v-flex>
      <v-layout row wrap px-3>
        <v-flex xs12>
          <v-flex>
            <label class="control-label">{{ trans('template.ranges') }} </label>
            <search-select
                :class="'range-select'"
                :default="rangeLength"
                :data="rangeLengthOptions"
                :type="`array`"
                ref="rangeSelect"
                :disabled="!hasPermission('menu_schema_print_ranges')"
                @item-selected="rangeLengthOptionSelected">
            </search-select>
            <label class="control-label">{{ 'template.range_days'|trans }}</label>
          </v-flex>
        </v-flex>
        <v-flex xs12>
          <label class="control-label">{{ 'template.ranges_preview'|trans }}:</label>
          <ul class="d-flex range-preview-container">
            <li v-for="range in rangesPreview">
              <span v-if="range.length === 1" class="text-lowercase">{{ range[0] }} {{ 'app.day'|trans }}</span>
              <span v-else>{{ range[0] }} - {{
                  range[range.length - 1]
                }} ({{ getRangeName(range[range.length - 1] - range[0] + 1) }})</span>
            </li>
          </ul>
        </v-flex>
        <v-flex>
          <label class="control-label">{{ `template.adjust_ranges` | trans }}:</label>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap px-3 class="slider-content">
        <v-flex xs1>
          <label class="control-label slider-days-label">{{ `app.day` | trans }}:</label>
        </v-flex>
        <v-flex grow pr-3>
          <vue-slider
              :processStyle="{'background-color': '#00a65a'}"
              :tooltipStyle="{'background-color': '#00a65a'}"
              :labelStyle="{'margin-top':'13px'}"
              :disabled="!hasPermission('menu_schema_print_ranges')"
              :marks="true" @change="sliderChanged" :min="1" :max="numberOfDays" v-model="ranges"></vue-slider>
        </v-flex>
        <v-flex shrink>
          <v-btn pa-0 outline small icon :color="`primary`"
                 v-tooltip="trans('template.addRange')"
                 :disabled="!hasPermission('menu_schema_print_ranges') || ranges.length === numberOfDays"
                 @click="addRange()"
          >
            <v-icon v-bind="{small: true}">add</v-icon>
          </v-btn>
          <v-btn outline small icon :color="`red`"
                 v-tooltip="trans('template.removeRange')"
                 :disabled="ranges.length === 2"
                 @click="removeRange()"
          >
            <v-icon v-bind="{small: true}">delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </permission-tooltip>
</template>
<script>
import {mapGetters, mapState} from "vuex";
import {dateFromTimestamp} from "../../../utils/dateFormatter";

export default {
  data() {
    return {
      ranges: [],
      rangeLength: null,
      rangeLengthOptions: [],
      numberOfDays: null,
    }
  },
  created() {
    this.numberOfDays = this.calculateNumberOfDays();
    this.rangeLength = this.calculateRangeLength();
    this.ranges = this.calculateRanges();
    this.rangeLengthOptions = this.calculateRangeLengthOptions();
  },
  mounted() {
    this.$refs.rangeSelect.setValue(this.rangeLength);
  },
  computed: {
    ...mapState(['menu']),
    ...mapGetters(['selectedCombinedMenus', 'hasPermission']),
    rangesPreview() {
      return this.prepareRanges().map((range) => {
        if (range[1] === range[0]) {
          range = [range[0]];
        }
        return range.map(day => day + 1);
      });
    }
  },
  methods: {
    prepareRanges() {
      if (this.ranges.length === 2) {
        return [[this.ranges[0] - 1, this.ranges[1] - 1]];
      }

      let allRangesWithoutGap = true;
      for (let i = 1; i < this.ranges.length; i++) {
        if (this.ranges[i] - this.ranges[i - 1] > 1) {
          allRangesWithoutGap = false;
          break;
        }
      }
      if (allRangesWithoutGap) {
        return this.ranges.map((day) => {
          return [
            day - 1,
            day - 1,
          ]
        });
      }
      let ranges = [];
      for (let i = 1; i < this.ranges.length; i++) {
        if (i === 1) {
          ranges.push([
            this.ranges[0] - 1,
            this.ranges[1] - 1,
          ]);
        } else {
          ranges.push([
            this.ranges[i - 1],
            this.ranges[i] -1,
          ]);
        }
      }
      return ranges;
    },
    rangeLengthOptionSelected(value) {
      if (value !== undefined) {
        this.rangeLength = value.id;
        this.ranges = this.calculateRanges();
      } else {
        this.rangeLength = null;
      }
    },
    getRangeName(days) {
      return days + ' dni'
    },
    sliderChanged() {
      this.$refs.rangeSelect.reset();
      this.rangeLength = null
    },
    addRange() {
      this.$refs.rangeSelect.reset();
      this.rangeLength = null;
      const newRange = this.numberOfDays;
      if (!this.ranges.includes(newRange)) {
        this.ranges.push(newRange);
        return;
      }
      let freeRange = newRange;
      do {
        freeRange--;
      } while(this.ranges.includes(freeRange))
      this.ranges = this.ranges.map((range) => {
        if (range > freeRange) {
          return --range;
        }
        return range;
      });
      this.ranges.push(newRange);
    },
    removeRange() {
      this.rangeLength = null;
      this.$refs.rangeSelect.reset();
      //remove 2 last items and add new at the end
      this.ranges.pop();
      this.ranges.pop();
      this.ranges.push(this.numberOfDays);
    },
    calculateRanges() {
      const numberOfRanges = Math.floor(this.numberOfDays / this.rangeLength);
      let ranges = [1];
      for(let range = 1; range <= numberOfRanges; range ++) {
        if (!ranges.includes(range * this.rangeLength)) {
          ranges.push(range * this.rangeLength);
        }
      }
      if (!ranges.includes(this.numberOfDays)) {
        ranges.push(this.numberOfDays);
      }
      return ranges;
    },
    calculateRangeLengthOptions() {
      let rangeLengthOptions = [];
      for (let i = 1; i <= this.numberOfDays; i++) {
        rangeLengthOptions.push({
          id: i,
          text: i,
        });
      }
      return rangeLengthOptions;
    },
    calculateRangeLength() {
      return this.numberOfDays < 7 ? this.numberOfDays : 7;
    },
    calculateNumberOfDays() {
      let numberOfDays = this.menu.getNumberOfDays();
      this.selectedCombinedMenus.forEach((selectedCombinedMenu) => {
        numberOfDays = selectedCombinedMenu.days > numberOfDays ? selectedCombinedMenu.days : numberOfDays;
      })
      return numberOfDays;
    },
    convertRangesToDates() {
      return this.prepareRanges()
          .map((range) => {
            let dates = [];
            for (let i = range[0]; i <= range[1]; i++) {
              const day = this.menu.schema.days[i];
              if (day === undefined) {
                const lastDayIndex = this.menu.schema.days.length - 1;
                const lastDay = this.menu.schema.days[lastDayIndex];
                dates.push(dateFromTimestamp(lastDay.date)
                    .add(i-lastDayIndex, 'd')
                    .format());

              } else {
                dates.push(dateFromTimestamp(day.date).format());
              }

            }
            return dates;
          });
    },
  },
}
</script>
<style scoped>
.range-preview-container {
  flex-direction: column;
  height: 70px;
  flex-wrap: wrap;
}
.slider-days-label {
  position: absolute;
  margin-top: 16px;
}
.slider-content {
  height:65px;
}
.range-select {
  width: 55px;
  display: inline-block;
}
</style>